import API from "../../common/utils/API";
import {apiActionsBillingReports} from "../../billing/billing-reports/constants/BillingReportActionConstants";
import {generateCSVReportSuccess} from "../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {
    showDownloadResponseMessage,
    showRunResponseMessage, updateSapStatus, getSapFileUploadStatus
} from "../../billing/billing-reports/actions/BillingReportActions";


const billingReportsMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsBillingReports.POST_UPDATE_LINKS: {
            next(action)

            API.postUpdateLinks(action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(showRunResponseMessage(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.POST_MONTHLY_ROLLUP: {
            next(action)

            API.postMonthlyRollup(action.payload.date, action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(showRunResponseMessage(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.GET_BILLING_REPORT: {
            next(action);

            API.getBillingReport(action.payload.date, action.payload.authToken.idToken)
                .then(res => {
                    const filename = "gdc_" + action.payload.date + ".csv";
                    store.dispatch(generateCSVReportSuccess(res.data, filename));
                    store.dispatch(showDownloadResponseMessage(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.POST_BILLING_REPORT: {
            next(action);

            API.postBillingReport(action.payload.date, action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(showRunResponseMessage(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.POST_RUN_PRICING: {
            next(action);

            API.postRunPricing(action.payload.date, action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(showRunResponseMessage(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.GET_UPLOAD_SAP_FILE: {
            next(action);

            API.getEntropyString(action.payload.authToken.idToken)
                .then(res => {
                    const entropyStr = res.data.entropy;

                    API.getSapInputFile(action.payload.date, entropyStr, action.payload.authToken.idToken)
                        .then(inputFileRes => {
                            store.dispatch(getSapFileUploadStatus(action.payload.date));
                        })
                        .catch(err=> {
                            store.dispatch(showDownloadResponseMessage(err.response.data));
                        })
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsBillingReports.GET_SAP_INPUT_FILE: {
            API.getSapInputFile(action.payload.date, action.payload.entropy, action.payload.authToken.idToken)
                .then(inputFileRes => {
                    const filename = "sap_input_file_" + action.payload.date + "_" + action.payload.entropy + ".txt"
                    store.dispatch(generateCSVReportSuccess(inputFileRes.data, filename));
                    store.dispatch(showDownloadResponseMessage(inputFileRes.data));
                })
                .catch(err=> {
                    store.dispatch(showDownloadResponseMessage(err.response.data));
                })
            break;
        }

        case apiActionsBillingReports.GET_SAP_USAGE_CONTROL_FILE: {
            API.getSapUsageControlFile(action.payload.date, action.payload.entropy, action.payload.authToken.idToken)
                .then(usageControlRes => {
                    const filename = "sap_usage_control_file_" + action.payload.date + "_" + action.payload.entropy + ".csv"
                    store.dispatch(generateCSVReportSuccess(usageControlRes.data, filename));
                    store.dispatch(showDownloadResponseMessage(usageControlRes.data));
                })
                .catch(err=> {
                    store.dispatch(showDownloadResponseMessage(err.response.data));
                })
            break;
        }

        case apiActionsBillingReports.GET_SAP_UPLOAD_STATUS: {
            next(action);

            API.getSapUploadStatus(action.payload.date, action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(updateSapStatus(res.data));
                })
                .catch(err => console.error(err));
            break;
        }

        default: next(action)
    }
}

export default billingReportsMiddleware;
